import { LogoutOutlined, UserOutlined } from "@ant-design/icons";

import { Avatar, Dropdown, Menu } from "antd";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import { useAuth } from "../../../../auth/AuthContext";
import "./styles.css";
import { useEffect, useState } from "react";

/**
 * @class
 * @name SignOut
 * @description carries  sing out component
 */
const SignOutWrapper = () => {
  const { logout } = useAuth();
  return (
    <div onClick={logout}>
      <LogoutOutlined />
      <span style={{ padding: 10 }}>Sign Out</span>
    </div>
  );
};

/**
 * @function
 * @param {object} props User menu props
 * @param {object} props.history history object
 * @param {Function} props.history.push push handler
 * @name UserMenu
 * @description Menu for shown when user click user icon at the top bar
 * @returns {object} User Menu component
 * @version 0.1.0
 * @since 0.1.0
 */
const UserMenu = ({ history: { push } }) => {
  const { user: authUser } = useAuth();
  const [userName, setUserName] = useState("");
  useEffect(() => {
    const fullName = `${authUser?.first_name || ''} ${authUser?.last_name || ''}`.trim();
    setUserName(fullName || authUser?.email || "User");
  }, [authUser]);

  const getUserInitials = (user) => {
    if (!user) return 'U';
    const firstName = user.first_name || '';
    const lastName = user.last_name || '';
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase() || user.email?.charAt(0).toUpperCase() || 'U';
  };

  const onClickMenu = ({ key }) => {
    if (key === "account") {
      push("/settings/account");
    } else if (key === "signOut") {
      // Logout is handled by SignOutWrapper
    }
  };

  const menuItems = [
    {
      key: "account",
      label: (
        <span>
          <UserOutlined /> {userName}
        </span>
      ),
      onClick: () => onClickMenu({ key: "account" }),
    },
    {
      key: "signOut",
      label: <SignOutWrapper />,
      onClick: () => onClickMenu({ key: "signOut" }),
    },
  ];

  return (
    <div className="UserMenu">
      <Dropdown overlay={<Menu className="UserProfileMenu" items={menuItems} />}>
        <Avatar 
          className="UserButton" 
          style={{ 
            backgroundColor: '#1890ff', 
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          {getUserInitials(authUser)}
        </Avatar>
      </Dropdown>
    </div>
  );
};

UserMenu.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(UserMenu);
